import React from 'react';
import { Button, Divider, Grid, Icon } from '@material-ui/core';
import { ClientContext } from '../ClientContext';
import { ClientPageTabs } from '../enums/ClientPageTabs';


export function ClientNavigation() {
    const clientContext = React.useContext(ClientContext);  
    interface ClientNavigationFunctionProps { 
        firstText?: string;
        firstPage?: ClientPageTabs;
        secondText?: string;
        secondPage?: ClientPageTabs;
    }

    const getButtons = (page: ClientPageTabs | undefined, icon: string, text: string, iconStart: boolean) => {
        return (
            <Button 
                onClick={() => clientContext.setClientPage(page ? page : ClientPageTabs.DEFAULT)}
                endIcon={!iconStart && (
                    <Icon className={'material-icons-round'}>
                        {icon}
                    </Icon>)
                }
                startIcon={!!iconStart && (
                    <Icon className={'material-icons-round'}>
                        {icon}
                    </Icon>)
                }>
                {text}
            </Button>
        );
    };

    const getNavigation = (props: ClientNavigationFunctionProps) => {
        return (
            <>
                <Grid item> 
                    {!!props.firstText && (
                        getButtons(props.firstPage, 'keyboard_arrow_left', props.firstText, true)
                    )}
                </Grid>
                <Grid item> 
                    {!!props.secondText && (
                        getButtons(props.secondPage, 'keyboard_arrow_right', props.secondText, false)
                    )}
                </Grid>
            </>
        );
    };
    
    return (
        <Grid item xs={12}>
            <Divider />
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                {clientContext.clientPage === ClientPageTabs.ORGANOGRAM_CUTOUT && getNavigation({
                    secondText: 'Ir para origem das matérias', 
                    secondPage: ClientPageTabs.NEWS_ORIGIN
                })}
                {clientContext.clientPage === ClientPageTabs.NEWS_ORIGIN && getNavigation({
                    firstText: 'Ir para organograma e recortes', 
                    firstPage: ClientPageTabs.ORGANOGRAM_CUTOUT,
                    secondText: 'Ir para tags e teor', 
                    secondPage: ClientPageTabs.TAGS
                })}
                {clientContext.clientPage === ClientPageTabs.TAGS && getNavigation({
                    firstText: 'Ir para origem das matérias', 
                    firstPage: ClientPageTabs.NEWS_ORIGIN,
                    secondText: 'Ir para dashboard', 
                    secondPage: ClientPageTabs.DASHBOARD
                })}
                {clientContext.clientPage === ClientPageTabs.DASHBOARD && getNavigation({
                    firstText: 'Ir para tags e teor', 
                    firstPage: ClientPageTabs.TAGS,
                    secondText: 'Ir para redes sociais', 
                    secondPage: ClientPageTabs.SOCIAL_MEDIA
                })}
                {clientContext.clientPage === ClientPageTabs.SOCIAL_MEDIA && getNavigation({
                    firstText: 'Ir para dashboard', 
                    firstPage: ClientPageTabs.DASHBOARD
                })}
            </Grid>
        </Grid>
    );
}